import { useState } from "react";
import { useNavigate } from "react-router-dom";

const VisitorTermsVM = () => {
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);

  const handleAgree = () => {
    navigate("/visitor-mgmt/visitor-form");
  };

  const handleCheckboxChange = (event) => {
    setAgreed(event.target.checked);
  };

  return {
    agreed,
    handleAgree,
    handleCheckboxChange,
  };
};

export default VisitorTermsVM;
